import { useState } from "react";
import { useAuthContext } from "./useAuthContext";

export const useLogin  = () => {
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(null)
    const { dispatch } = useAuthContext()

    const login = async (name,password) => {
        setIsLoading(true)
        setError(null)

        const response = await fetch('users/login', {
            method: 'POST',
            headers: {'Content-Type': 'application/json',
            "Access-Control-Allow-Origin" : "*", 
            "Access-Control-Allow-Credentials" : true },
            body: JSON.stringify({name, password})
        })

        const json = await JSON.parse(response)

        if (!response.ok) {
            setIsLoading(false)
            setError(json.error)
        }

        if (response.ok) {
            //save the user to local storage
            localStorage.setItem('user', JSON.stringify(json))

            //update the auth context
            dispatch({type: 'LOGIN', payload: json})

            setIsLoading(false)
        }
    }

    return { login, isLoading, error}
}